import { partitionVisitServices } from '../../admin-shared/checkinServiceDesk';
import { isSalonReadyForStylist } from './visitIntent';
import { ongoingLines } from './serviceLineUtils';
import { canLobbyAnalysisPreview } from './lobbyReportSessions';

export function lobbyActionForVisit(checkin, pinsForVisit = []) {
  for (const pin of pinsForVisit) {
    if (ongoingLines(checkin?.selected_services, pin.stylistId).length) {
      return { label: 'Finish', mode: 'work', pin };
    }
  }
  if (!isSalonReadyForStylist(checkin)) {
    return { label: 'Waiting', mode: 'disabled', pin: pinsForVisit[0] || null };
  }
  return { label: 'Open', mode: 'pick', pin: pinsForVisit[0] || null };
}

export function lobbyShowAnalysisPreview(checkin) {
  const snap = checkin?.customer_snapshot || {};
  const cartPending =
    Boolean(snap.product_cart_pending) ||
    (Array.isArray(snap.product_cart) && snap.product_cart.length > 0);
  return cartPending || canLobbyAnalysisPreview(checkin);
}

export function visitCanContinueFromLobby(checkin) {
  if (!checkin?.id) return false;
  const status = String(checkin?.status || '').toLowerCase();
  if (status === 'cancelled') return false;
  if (status === 'completed') return true;
  const { inProgress, pending } = partitionVisitServices(checkin?.selected_services);
  return inProgress.length > 0 || pending.length > 0 || isSalonReadyForStylist(checkin);
}
